import React from 'react';

import BottomSheet from '@rover/kibble/official-patterns/BottomSheet';
import Modal from '@rover/kibble/official-patterns/Modal';
import MQ from '@rover/kibble/styles/MediaQuery';
import useMatchMedia from '@rover/react-lib/src/hooks/useMatchMedia';

type ContainerProps = {
  children: React.ReactNode;
  isOpen: boolean;
  onRequestClose: () => void;
  closeOnDragDown?: boolean;
};

const DisplayContainer = ({
  children,
  isOpen,
  closeOnDragDown,
  onRequestClose,
}: ContainerProps): JSX.Element => {
  const isMobile = useMatchMedia(MQ.MOBILE.getBreakpointString());
  if (isMobile) {
    return (
      <BottomSheet
        onRequestClose={onRequestClose}
        isOpen={isOpen}
        isDismissible
        closeOnDragDown={closeOnDragDown}
      >
        {children}
      </BottomSheet>
    );
  }
  return (
    <Modal onRequestClose={onRequestClose} isOpen={isOpen}>
      {children}
    </Modal>
  );
};
export default DisplayContainer;
